import { Injectable } from "@angular/core";
import {AuthenticationAbstractService} from "./abstract/authentication.abstract.service";

import * as jwt_decode from "jwt-decode";

@Injectable()
export class AuthenticationService implements AuthenticationAbstractService{

    private readonly TOKEN = 'token_umotion';

    set token(value: string) {
        localStorage.setItem(this.TOKEN, value);
    }

    get token(): string {
        return localStorage.getItem(this.TOKEN);
    }

    get isAuthenticated(): boolean {
        try {
            if(Date.now()/1000 <= jwt_decode(this.token).exp)
                return true;
        } catch (err) {
            this.logout();
            return false;
        }
        this.logout();
        return false;
    }

    get expirationDate(): Date {
        return new Date(jwt_decode(this.token).exp);
    }

    login(auth: string): any {
        this.token = auth;
    }

    logout(): any {
        localStorage.removeItem(this.TOKEN);
    }

}